import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ScrollReveal from 'scrollreveal';
import { useTranslation } from '../../LanguageContext';
import styles from './Process.module.css';

// ייבוא תמונות
import image1 from "../../images/בית פרטי בשילת 1.webp";
import image2 from "../../images/פנטהאוז תל אביבי - הגוש הגדול 1.webp";
import image3 from "../../images/בית מודרני ואלגנטי בכפר בילו 1.webp";
import image4 from "../../images/בית פרטי כפר אורנים 1.webp";
import image5 from "../../images/דירת קבלן משודרגת 1.webp";

const projectImages = [image1, image2, image3, image4, image5];

gsap.registerPlugin(ScrollTrigger);

// processSteps are now loaded from translations

const NarkisProcessStacking = () => {
  const { t, isEnglish } = useTranslation();
  const sectionRef = useRef(null);
  const cardsRef = useRef([]);
  const titleRef = useRef(null);
  const numbersRef = useRef([]);

  const processSteps = t.process.steps.map((step, i) => ({
    id: i + 1,
    number: String(i + 1).padStart(2, '0'),
    ...step,
  }));

  useEffect(() => {
    if (titleRef.current) {
      ScrollReveal().reveal(titleRef.current, {
        origin: 'bottom',
        distance: '40px',
        duration: 1000,
        delay: 200,
        easing: 'cubic-bezier(0.5, 0, 0, 1)',
        reset: false,
      });
    }

    const ctx = gsap.context(() => {
      const cards = cardsRef.current.filter(Boolean);
      const numbers = numbersRef.current.filter(Boolean);
      
      cards.forEach((card, index) => {
        const isFromRight = index % 2 === 0; 
        
        // כניסת כרטיס - מוגדר ל-1.8 שניות כפי שביקשת
        gsap.fromTo(card, 
          {
            x: isFromRight ? '120%' : '-120%', 
            opacity: 0,
          },
          {
            x: '0%', 
            opacity: 1,
            duration: 1.8, 
            ease: 'power3.out',
            scrollTrigger: {
              trigger: card,
              start: 'top 85%',
              toggleActions: 'play none none none',
            },
          }
        );

        // כניסת המספר האמנותי
        if (numbers[index]) {
            gsap.fromTo(numbers[index],
                { opacity: 0, scale: 0.9, y: 30 },
                { 
                    opacity: 1, 
                    scale: 1, 
                    y: 0,
                    duration: 1.5,
                    delay: 0.2, 
                    ease: 'power2.out',
                    scrollTrigger: {
                        trigger: card,
                        start: 'top 85%',
                    }
                }
            );
        }
      });

    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className={styles.processSection} ref={sectionRef}>
      <div className={styles.mainTitleWrapper} ref={titleRef}>
        <h2 className={styles.mainTitle}>{t.process.mainTitle}</h2>
      </div>

      <div className={styles.cardsContainer}>
        {processSteps.map((step, index) => {
          const isFromRight = index % 2 === 0;
          
          return (
            <div 
                key={step.id} 
                className={`${styles.stepWrapper} ${isFromRight ? styles.wrapperRight : styles.wrapperLeft}`}
            >
              
              <div
                ref={(el) => (cardsRef.current[index] = el)}
                className={`${styles.processCard} ${isFromRight ? styles.cardRight : styles.cardLeft}`}
              >
                <div 
                  className={styles.cardImageSide}
                  style={{ backgroundImage: `url("${projectImages[index]}")` }}
                >
                  <div className={styles.imageOverlay}></div>
                </div>

                <div className={styles.cardContentSide}>
                  <span className={styles.mobileStepNumber}>{step.number}</span>
                  <h3 className={styles.cardTitle}>{step.title}</h3>
                  <p className={styles.cardDescription}><strong>{step.description}</strong></p>
                  <div className={styles.cardHighlight}>
                    <span className={styles.highlightIcon}>✦</span>
                    <span className={styles.highlightText}>{step.highlight}</span>
                  </div>
                </div>
              </div>

              <div 
                className={styles.bigNumberContainer}
                ref={(el) => (numbersRef.current[index] = el)}
              >
                 {step.number}
              </div>

            </div>
          );
        })}
      </div>

      <div className={styles.ctaButtonWrapper}>
        <a 
          href="https://wa.me/972544998929?text=היי%20נרקיס%20הגעתי%20מהדף%20שלך%2C%20אשמח%20לשמוע%20עוד%20על.."
          target="_blank"
          rel="noopener noreferrer"
          className={styles.whatsappButton}
        >
          {t.process.ctaText}
        </a>
      </div>
    </section>
  );
};

export default NarkisProcessStacking;